import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import { OffCanvas } from "~assets/frontend/components/comp-offcanvas/comp-offcanvas";
import { OffCanvasSizeEnumValues } from "~assets/types/frontend/definitions/enums/OffCanvasSizeEnum";
const OffCanvasWrapper = ({ contentHtml, headline, overline, triggerElement, additionalTrigger, size = undefined, }) => {
    const [showCanvas, setShowCanvas] = useState(false);
    useEffect(() => {
        const handler = (event) => {
            event.preventDefault();
            setShowCanvas(true);
        };
        triggerElement === null || triggerElement === void 0 ? void 0 : triggerElement.addEventListener("click", handler);
        additionalTrigger === null || additionalTrigger === void 0 ? void 0 : additionalTrigger.addEventListener("click", handler);
        return () => {
            triggerElement === null || triggerElement === void 0 ? void 0 : triggerElement.removeEventListener("click", handler);
            additionalTrigger === null || additionalTrigger === void 0 ? void 0 : additionalTrigger.removeEventListener("click", handler);
        };
    }, [triggerElement, setShowCanvas, additionalTrigger]);
    return (React.createElement(OffCanvas, { showCanvas: showCanvas, onClose: () => setShowCanvas(false), headline: headline, overline: overline, content: React.createElement("div", { dangerouslySetInnerHTML: { __html: contentHtml } }), size: size }));
};
function getSizeEnumValue(value) {
    switch (value) {
        case OffCanvasSizeEnumValues.SIZE_30:
            return OffCanvasSizeEnumValues.SIZE_30;
        case OffCanvasSizeEnumValues.SIZE_60:
            return OffCanvasSizeEnumValues.SIZE_60;
        case OffCanvasSizeEnumValues.SIZE_100:
            return OffCanvasSizeEnumValues.SIZE_100;
        default:
            return undefined;
    }
}
export const OffCanvasLoader = (triggers) => {
    triggers.forEach((triggerElement) => {
        const headline = triggerElement.getAttribute("data-offcanvas-headline");
        if (!headline) {
            throw new Error("OffCanvas data-offcanvas-headline attribute is missing");
        }
        const overline = triggerElement.getAttribute("data-offcanvas-overline");
        let size = triggerElement.getAttribute("data-offcanvas-size");
        const contentElementId = triggerElement.getAttribute("data-offcanvas-content");
        if (!contentElementId) {
            throw new Error("OffCanvas data-offcanvas-content attribute is missing");
        }
        const contentElement = document.getElementById(contentElementId);
        if (!contentElement) {
            throw new Error(`OffCanvas data-offcanvas-content attribute is invalid: ${contentElementId}`);
        }
        const contentHtmlAsString = contentElement.innerHTML;
        const additionalTrigger = document.querySelector(`[data-offcanvas-trigger=${contentElementId}]`);
        // console.log(additionalTrigger, `[data-offcanvas-trigger=${contentElementId}]`)
        // Reuse content element as React root :-)
        contentElement.innerHTML = "";
        // contentElement.removeAttribute("class");
        // contentElement.removeAttribute("style");
        // Do not remove the class and style attributes, they are needed for hiding the original content container in flex flows ;-)
        // The OffCanvas is rendered using a portal anyways.
        const root = createRoot(contentElement);
        root.render(React.createElement(OffCanvasWrapper, { key: contentElementId, triggerElement: triggerElement, additionalTrigger: additionalTrigger ? additionalTrigger : undefined, headline: headline, overline: overline, contentHtml: contentHtmlAsString, size: getSizeEnumValue(size) || OffCanvasSizeEnumValues.SIZE_30 }));
    });
};
